var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z4m1854bda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1360 0v937H0V0h1360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2iiyevilsb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 0a.84.84 0 1 1 0 1.682H2.524a.841.841 0 0 0-.84.841V13.46c0 .464.376.84.84.84h9.253a.841.841 0 0 0 .841-.84v-2.643a.84.84 0 1 1 1.683 0v2.643a2.526 2.526 0 0 1-2.524 2.523H2.523A2.527 2.527 0 0 1 0 13.459V2.523A2.527 2.527 0 0 1 2.523 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3fwoi9gwjc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.318 0c.804.018 1.601.325 2.212.936a3.226 3.226 0 0 1 0 4.553l-5.686 5.687a4.39 4.39 0 0 1-3.119 1.29H.841A.84.84 0 0 1 0 11.625V9.74a4.39 4.39 0 0 1 1.289-3.118L6.983.93c.64-.64 1.49-.947 2.335-.928zM6.233 4.059 2.479 7.812a2.717 2.717 0 0 0-.797 1.929v1.043h1.043c.728 0 1.414-.284 1.93-.798l3.753-3.753-2.175-2.175zm4.107-1.932a1.54 1.54 0 0 0-2.175 0l-.743.742 2.176 2.176.742-.743c.6-.6.6-1.576 0-2.175z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z4m1854bda)",
    transform: "translate(-144 -164)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2iiyevilsb)",
    transform: "translate(145.359 166.32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14.3v15.982H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3fwoi9gwjc)",
    transform: "translate(150.204 165.277)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h12.47v12.466H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.dabf7b82dd80485be236a14aa94f8068.svg";
export { ForwardRef as ReactComponent };